import {useLogger, useTranslation} from '#imports';
import type {TJoySnackbarLevels} from '@maltjoy/core-vue';
import {createSnackNotifier} from '~/composables/snackNotifier';

export function useGenericErrorHandler() {
    const logger = useLogger();
    const notifier = createSnackNotifier();
    const {t} = useTranslation();

    function handleError(error: Error, customErrorMsg?: string, level?: TJoySnackbarLevels) {
        logger.error(error);
        const message = customErrorMsg || t('general.unexpected.error', [error.message ?? error]);
        notifier.push(level ?? 'error', message);
    }

    return {
        handleError,
    };
}
